import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { phoneNormalize } from 'shared/modules';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import withAddContactLogic from 'shared/hocs/withAddContactLogic';
import s from './ProfilePhoneInput.css';

const CODE_LENGTH = 6;
const PHONE_LENGTH = 12;

class ProfilePhoneInput extends Component {
  static propTypes = {
    resendVerifyCode: PropTypes.func.isRequired,
    getVerifyCode: PropTypes.func.isRequired,
    onOpenModal: PropTypes.func.isRequired,
    verifyPhone: PropTypes.func.isRequired,
    removeError: PropTypes.func.isRequired,
    onRemovePhoneClick: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool,
    serverError: PropTypes.string,
    // phone fields
    phoneId: PropTypes.number,
    isVerified: PropTypes.bool,
    isSendCode: PropTypes.bool,
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    index: PropTypes.number.isRequired,
    intl: intlShape.isRequired,
    isMobile: PropTypes.bool,
    canBeRemoved: PropTypes.bool,
  };

  static defaultProps = {
    isVerified: undefined,
    serverError: null,
    phoneId: null,
    isSubmitting: false,
    isSendCode: false,
    sendCodeTimer: false,
    isMobile: false,
    canBeRemoved: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      isRecentlySendCode: false,
      isSendCode: !!props.isSendCode,
      code: '',
      number: props.number,
    };
  }

  handleSendCode = () => {
    const { number, resendVerifyCode } = this.props;
    this.setState({ isSendCode: true });

    resendVerifyCode(number);
  };

  handleChangeCode = e => {
    const { value: code } = e.target;

    if (new RegExp(/\D/g).test(code) || code.length > CODE_LENGTH) {
      return;
    }

    this.props.removeError();
    this.setState({ code });
  };

  handleChangePhone = e => {
    const { value: number } = e.target;

    if (
      !new RegExp(`^380`).test(number.substring(0)) ||
      !new RegExp(`^[0-9]{3,${PHONE_LENGTH}}$`).test(number.substring(0))
    ) {
      return;
    }

    this.props.removeError();
    this.setState({ number });
  };

  handleVerifyPhone = () => {
    const { code } = this.state;
    const { number, verifyPhone } = this.props;
    verifyPhone({ phone: number, code });
  };

  handleRemovePhone = () => {
    this.props.onRemovePhoneClick(this.props.index);
  };

  handleRemoveProfilePhone = () => {
    if (this.props.phoneId) {
      this.props.onOpenModal(this.props.phoneId);
    } else {
      this.props.onOpenModal({ number: this.props.number });
    }
  };

  handleGetVerifyCode = () => {
    this.props.getVerifyCode(this.state.number);
    this.setState({ isSendCode: true });
  };

  handleResendCode = () => {
    this.props.resendVerifyCode(this.state.number);
    this.setState({ sendCodeTimer: true }, () => {
      setTimeout(() => {
        this.setState({ sendCodeTimer: false });
      }, 30000);
    });
  };

  render() {
    const {
      serverError,
      isSubmitting,
      // phone props
      isVerified,
      index,
      isMobile,
      canBeRemoved,
      //
      intl,
    } = this.props;
    const { isSendCode, code, number, sendCodeTimer } = this.state;

    return (
      <div className={cx(s.phoneContainer, { [s.mobile]: isMobile })}>
        {(() => {
          if (isVerified) {
            return (
              <div className={s.phoneInput}>
                <i className={`fa fa-check ${s.verifiedIcon}`} />
                <div className={s.inputContainer}>
                  <input type="text" className={s.input} value={phoneNormalize(number)} disabled />
                </div>
                {canBeRemoved &&
                  <i
                    data-button={intl.formatMessage({ id: `Удалить` })}
                    title={intl.formatMessage({ id: `Удалить телефонный номер` })}
                    className={`fa fa-remove ${s.removeIcon}`}
                    onClick={this.handleRemoveProfilePhone}
                  />}
              </div>
            );
          } else if (isVerified === false) {
            return (
              <div>
                {!isSendCode
                  ? <div className={s.phoneInput}>
                      <i className={`fa fa-warning ${s.warningIcon}`} />
                      <div className={s.inputContainer}>
                        <input
                          type="text"
                          className={s.input}
                          disabled
                          value={phoneNormalize(number)}
                        />
                      </div>
                      <div className={s.buttons}>
                        <i
                          data-button={intl.formatMessage({ id: `Удалить` })}
                          title={intl.formatMessage({ id: `Удалить телефонный номер` })}
                          className={`fa fa-remove ${s.removeIcon}`}
                          onClick={this.handleRemoveProfilePhone}
                        />
                        <span className={s.sendAnotherCode}>
                          <FormattedMessage id="Телефон не подтвержден." />{' '}
                          <span onClick={this.handleSendCode} className={s.span}>
                            <FormattedMessage id="Выслать код" />
                          </span>
                        </span>
                      </div>
                    </div>
                  : <div className={s.phoneInput}>
                      <i className={`fa fa-warning ${s.warningIcon}`} />
                      <div className={s.inputContainer}>
                        <input
                          type="text"
                          className={s.input}
                          name={index}
                          value={code}
                          onChange={this.handleChangeCode}
                          placeholder={intl.formatMessage({ id: 'Введите код с сообщения' })}
                        />
                        {code &&
                          code.length === CODE_LENGTH &&
                          <button
                            disabled={isSubmitting}
                            onClick={this.handleVerifyPhone}
                            className={s.verifyButton}
                          >
                            <FormattedMessage id="OK" />
                          </button>}
                      </div>

                      {!sendCodeTimer &&
                        <span onClick={this.handleResendCode} className={s.sendAnotherCode}>
                          <div>
                            <FormattedMessage id="Не пришла смс" />?{' '}
                          </div>
                          <span className={s.span}>
                            <FormattedMessage id="Выслать код ещё раз" />
                          </span>
                        </span>}
                    </div>}
              </div>
            );
          } else if (isVerified === undefined) {
            return (
              <div>
                <div className={s.phoneInput}>
                  <div className={s.inputContainer}>
                    <input
                      type="text"
                      disabled={isSubmitting}
                      className={s.input}
                      name={index}
                      value={number}
                      onChange={this.handleChangePhone}
                    />
                    {number.length === PHONE_LENGTH &&
                      !isSubmitting &&
                      <button onClick={this.handleGetVerifyCode} className={s.verifyButton}>
                        <FormattedMessage id="OK" />
                      </button>}
                  </div>
                  <span onClick={this.handleRemovePhone} className={s.removePhone}>
                    <FormattedMessage id="Удалить" />
                  </span>
                </div>
              </div>
            );
          }

          return null;
        })()}

        {serverError &&
          <div className={s.serverError}>
            {serverError && typeof serverError === 'string'
              ? <FormattedMessage id={serverError} />
              : serverError}
          </div>}
      </div>
    );
  }
}

export default withAddContactLogic(withStyles(s)(injectIntl(ProfilePhoneInput)));



// WEBPACK FOOTER //
// ./src/desktop/components/ProfilePhoneInput/ProfilePhoneInput.js